import { PlatformBuyBody, SubscriptionApi } from '@bpm-web-app/supreme-api-sdk';
import { supremeConfig } from '../config';

export class Gift {
    static client = new SubscriptionApi(supremeConfig);

    static buyGift = (platform: string, body?: PlatformBuyBody) => Gift.client.buyGift(platform, body);

    static validateGift = (code: string) => Gift.client.validateGiftCode(code);

    static redeeemGift = (code: string) => Gift.client.redeemGiftCode({ code });
}
